import { styled } from 'styled-components';
import { device } from '@/styles/helpers';
import { type ThemeConfig, themeConfig } from './helpers';

interface IScStepsLandingProps {
  colorScheme: keyof typeof themeConfig;
  themes: ThemeConfig;
}

export const ScStepsLanding = styled.div<IScStepsLandingProps>`
  display: grid;
  grid-template-columns: 1fr 72px 1fr 72px 1fr;
  align-items: center;
  gap: 16px;
  @media (${device.tablet}) {
    grid-template-columns: 1fr;
  }

  & .step {
    padding-left: 36px;
    cursor: pointer;

    @media (${device.tablet}) {
      padding-left: 0;
    }

    & > .content {
      position: relative;
      padding: 16px 16px 16px 40px;
      border-radius: 12px;
      box-shadow: ${({ theme, colorScheme }) =>
        `inset 0 0 0 2px ${themeConfig[colorScheme].borderColor(theme)}`};
      background-color: ${({ theme, colorScheme }) =>
        themeConfig[colorScheme].background(theme)};
      display: flex;
      gap: 12px;
      width: 100%;
      min-height: 120px;
      min-width: 279px;
      transition: background-color 0.3s ease-in-out;

      @media (${device.tablet}) {
        padding: 12px;
        align-items: center;
        min-height: 74px;
      }

      & > .benefit {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        font-weight: 700;
        @media (${device.tablet}) {
          flex-grow: 1;
          gap: 2px;
        }

        & > .title {
          font-size: 22px;
          line-height: 28px;
          letter-spacing: 0.22px;
          white-space: pre-line;
          @media (${device.tablet}) {
            font-size: 18px;
            line-height: 24px;
          }
        }

        & > .description {
          color: ${({ colorScheme }) =>
            themeConfig[colorScheme].descriptionColor};
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.16px;
        }
      }

      & > img {
        position: absolute;
        top: 50%;
        left: -38px;
        transform: translateY(-50%);
        left: -38px;

        @media (${device.tablet}) {
          position: static;
          flex-shrink: 0;
          transform: translateY(0);

          &:first-child {
            width: 24px;
            height: 24px;
          }
        }
      }

      @media (hover: hover) {
        &:hover {
          background-color: ${({ theme, colorScheme }) =>
            themeConfig[colorScheme].hoverBackground(theme)};

          & > .benefit {
            & > .title,
            & > .description {
              color: ${({ theme, colorScheme }) =>
                themeConfig[colorScheme].hoverText(theme)};
            }
          }
        }
      }
    }
  }
`;
